import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_MODAL_ADD_NEW: string = typeCreatorV2(
  'TaskReducer',
  'SetModelAddNew'
);

export const SET_MODAL_VIEW_TASK: string = typeCreatorV2(
  'TaskReducer',
  'SetModalViewTask'
);

export const ADD_NEW_TASK: string = typeCreatorV2('TaskReducer', 'AddNewTask');
export const UPDATE_TASK: string = typeCreatorV2('TaskReducer', 'UpdateTask');
export const DELETE_TASK: string = typeCreatorV2('TaskReducer', 'DeleteTask');

export const SET_TASK_LIST: string = typeCreatorV2(
  'TaskReducer',
  'SetTaskList'
);

export const SET_CUSTOMER_NAME: string = typeCreatorV2(
  'TaskReducer',
  'SetCustomerName'
);
export const SET_PROPERTY_NAME: string = typeCreatorV2(
  'TaskReducer',
  'SetPropertyName'
);

export const SET_VIEW_TASK: string = typeCreatorV2(
  'TaskReducer',
  'SetViewTask'
);

export const CHANGE_STATUS_TASK: string = typeCreatorV2(
  'TaskReducer',
  'ChangeStatusTask'
);

export const UPLOAD_FILE_TASK: string = typeCreatorV2(
  'AppointmentReducer',
  'UploadFileTask'
);

export const UPLOAD_FILE_COMMENT: string = typeCreatorV2(
  'AppointmentReducer',
  'UploadFileComment'
);

export const COMMENT_TASK: string = typeCreatorV2(
  'AppointmentReducer',
  'CommentTask'
);
export const SET_COMMENT_TASK: string = typeCreatorV2(
  'AppointmentReducer',
  'SetCommentTask'
);
export const LIKE_TASK: string = typeCreatorV2(
  'AppointmentReducer',
  'LikeTask'
);

export const SET_STATUS_LANE: string = typeCreatorV2(
  'AppointmentReducer',
  'SetStatusLane'
);

export const SET_AGENT_NAME: string = typeCreatorV2(
  'AppointmentReducer',
  'SetAgentName'
);

export const SET_SHARING_APPOINTMENT: string = typeCreatorV2(
  'AppointmentReducer',
  'SetSharingAppointment'
);

export const SET_ASSIGNESS: string = typeCreatorV2(
  'AppointmentReducer',
  'SetAssigness'
);
